import * as Inputs from '@arch-log/webapp.atomics/components/Form/Input.v2/Renderers'

/**
 */
export const FirstName = Inputs.Text
export const LastName = Inputs.Text
export const PhoneticFirstName = Inputs.Text
export const PhoneticLastName = Inputs.Text
